import React, { useState, useEffect, useRef, useContext } from "react";
import noProfilePictureImage from "./images/no-user.png";
import "date-fns";
// import "react-dropdown/style.css";
import { NotificationManager } from "react-notifications";
import "./profileCompletion.css";
import Tooltip from "@mui/material/Tooltip";
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';


import view from "./images/view.png";
import pdfIcon from "../../../pages/myTalentCommunity/icons/pdf.svg";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';

import MuiDialogActions from "@mui/material/DialogActions";
import { BlobServiceClient } from "@azure/storage-blob";
import Skeleton from '@mui/material/Skeleton';
import TimelineIcon from '@mui/icons-material/Timeline';
import pencil from '../../../components/profile/primarySkills/images/pencil.png';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import getAllPrimarySkillData from "../../../apis/getAllPrimarySkillData";
import CloseIcon from "@mui/icons-material/Close";
import PhoneInput, { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import updateResume from "../../../apis/updateCandidateResumeById/updateCandidateResumeById";
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import countNoOfFilesParsed from "../../../apis/parsing/countNoOfFilesParsed";
import uploadResumeLogs from "../../../apis/uploadResumeLogs/uploadResumeLogs";
import downloadResumeLogs from "../../../apis/downloadResumeLogs/downloadResumeLogs";
import SHA256 from 'crypto-js/sha256';
import configJSON from "../../../Config.json"
import UploadResumeModal from "../../UploadResumeModal/UploadResumeModal";
import { UserTypeContext } from "../../../AppRoute";
import fetchCountryStateCity from "../../../apis/fetchCountryStateCity";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const DialogActions = (props) => (
    <MuiDialogActions
        {...props}
        sx={{
            margin: 0,
            padding: '16px',
            ...(props.sx || {}),
        }}
    />
);

const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option) => option.name,
});

const ProfileCompletion = ({
    candidateData,
    loadingController,
    profileCompletion,
    userId,
    userType,
    userRecruitmentPartnerId,
    backdropChangeHandler
}) => {
    const jsonConfig = require("../../../Config.json");
    const [candidateProfileData, setCandidateProfileData] = useState(candidateData);
    const statusCode = candidateProfileData?.candidateRequisitionDetails?.status?.candidateStatusCode
    const companyName = candidateProfileData?.candidateRequisitionDetails?.requisitionDetailData?.clientData?.clientName
    const { userRecords } = useContext(UserTypeContext);
    const idContextTest = userRecords?.id;
    const [candidateProfileModalData, setCandidateProfileModalData] = useState({
        name: "",
        emailID: "",
        phoneNumber: "",
        countryCode: "",
        countryCallingCode: "",
        country: "",
        currency: "",
        state: "",
        city: "",
        primarySkill: "",
        additionalSkills: [],
        yearsOfExperience: "",
        currentCompensation: "",
        expectedCompensation: "",
        noticePeriod: "",
        phoneNumberInt: ""
    });
    const [locationList, setLocationList] = useState({
        countryList: [],
        stateList: [],
        cityList: [],
        isCountryFetching: false,
        isStateFetching: false,
        isCityFetching: false,
        isCurrencyFetching: false,
    });



    const getProcessedTestData = () => {
    const testData = candidateProfileData?.testData || {};
    const aiTests = testData?.aiTests || [];
    const vetTests = testData?.vetTests || [];

    const formattedAITests = aiTests.map(test => ({
        id: test._id,
        name: test?.jobDetails?.jobTitle 
    }));

    const formattedVetTests = vetTests.map(test => ({
        id: test.id,
        name: test?.vetCandidateTestId?.testName 
    }));

    return {
        AI: formattedAITests,
        VET: formattedVetTests
    };
};

    const [isUserdataUpdating, setisUserdataUpdating] = useState(false);
    const profilePicture = noProfilePictureImage
    const [isEmailCopied, setisEmailCopied] = useState(false);
    const history = useNavigate();
    const [wrappedAdditionalSkills, setWrappedAdditionalSkills] = useState(false);

    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const [primarySkill, setPrimarySkill] = useState([]);
    const candidateResumeId = candidateProfileData?.candidateId
    const currencyList = locationList.countryList;
    const [additionalSkills, setAdditionalSkills] = useState([]);
    const [phoneError, setPhoneError] = useState(null);
    const [currentAdditionalValue, setCurrentAdditionalValue] = useState("");
    const [isPrimarySkillChange, setIsPrimarySkillChange] = useState(false);
    const [selectedFile, setSelectedFile] = useState({});
    const uploadedFileParseCount = useRef(0);

    const [showResumeModal, setShowResumeModal] = useState(false);

    const navigateToTestAnalysis = (testId, testType) => {
    if (testId) {
        history(`/candidate-interview-analysis/${testId}?int=${testType}`);
    }
};

    const fileExtension = (resumeUrl) => {
        let extension = resumeUrl.split(".").pop().toLowerCase();
        if (extension === "pdf") {
            return <img src={pdfIcon} alt="PDF Icon" className="fileImg_resume" />;
        } else if (extension === "doc" || extension === "docx") {
            return <img src={view} alt="DOC Icon" className="fileImg_resume" />;
        }
    };

    const fileExtensionArr = (oldProfiles) => {
        let extension = oldProfiles.split(".").pop().toLowerCase();
        if (extension === "pdf") {
            return (
                <img src={pdfIcon} alt="PDF Icon" className="fileImg" />
            );
        } else if (extension === "doc" || extension === "docx") {
            return (
                <img src={view} alt="DOC Icon" className="fileImg" />
            );
        }
    };

    const fileExtensionuploadResume = () => {
        if (selectedFile?.name) {
            let extension = selectedFile?.name.split('.').pop().toLowerCase();
            if (extension === 'pdf') {
                return <img src={pdfIcon} alt="PDF Icon" className="new_candidate_icon_profilecomplete" />
            } else if (extension === 'doc' || extension === 'docx') {
                return <img src={view} alt="DOC Icon" className="new_candidate_icon_profilecomplete" />
            }
        }


    }

    const openResume = async (resumeUrl) => {
        await downloadResumeLogs({ userId: localStorage.getItem('userID'), recruitementPartnerId: userRecruitmentPartnerId })
        window.open(resumeUrl, "_blank");
    };

    const getWrapItem = (item) => {
        let wordCount = item.split(" ");
        let word = "";
        if (wordCount.length > 5) {
            word =
                wordCount[0] +
                " " +
                wordCount[1] +
                " " +
                wordCount[2] +
                " " +
                wordCount[4] +
                " " +
                wordCount[5] +
                "...";
        } else word = item;
        return word;
    };

    const changeCopyText = () => {
        setisEmailCopied(false);
    };
    const copyEmail = (e, useremail) => {
        setisEmailCopied(true);
        navigator.clipboard.writeText(useremail);
        setTimeout(changeCopyText, 3000);
    };

    const testData = getProcessedTestData();

    const getWrappedSecondarySkills = (skills) => {
        let arrData = [];
        skills?.forEach((item, i) => {
            if (i <= 15) {
                arrData.push(
                    <Tooltip key={i} title={item}>
                        <div className="chipStyle ">
                            <span className="chipstyle_skill_font">{getWrapItem(item)}</span>
                        </div>
                    </Tooltip>
                )
            }
        })
        return arrData;
    }

    const getAllSecondarySkills = (skills) => {
        let arrData = [];
        skills?.map((item) =>
            arrData.push(
                <Tooltip title={item}>
                    <div className="chipStyle ">
                        <span className="chipstyle_skill_font">{getWrapItem(item)}</span>
                    </div>
                </Tooltip>
            )
        )
        return arrData;
    }

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#1A8FFF',
            padding: '4px 13px',
            fontFamily: 'Segoe-Semibold',
            fontSize: '13px',
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: '#1A8FFF',
        },
    }));

    const getWrappedEmail = (email) => {
        let wrappedemail = email.length > 28 ? email.substring(0, 28) + "..." : email;
        return (
            <BootstrapTooltip title={isEmailCopied ? "Copied" : "Click to copy Email"}>
                <span className="candidateDetails" onClick={(e) => copyEmail(e, email)}>{wrappedemail}</span>
            </BootstrapTooltip>
        );
    }

    const closeAddModal = () => {
        setmodalIsOpen(false);
        setIsPrimarySkillChange(false);
        setCandidateProfileModalData({
            name: "",
            emailID: "",
            phoneNumber: "",
            countryCode: "",
            countryCallingCode: "",
            country: "",
            currency: "",
            state: "",
            city: "",
            primarySkill: "",
            additionalSkills: [],
            yearsOfExperience: "",
            currentCompensation: "",
            expectedCompensation: "",
            noticePeriod: "",
        })
    }

     const fetchLocationCurrency = async (field) => {
        if (field === "country") {
            setLocationList((prev) => ({
                ...prev,
                isCurrencyFetching: true,
            }));
            try {
                let payload = {
                    actionName: "country"
                }

                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isCurrencyFetching: false,
                        countryList: response.data.data
                    })
                }
            } catch (error) {
                NotificationManager.error(
                    "Unable to load country list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isCountryFetching: false,
                    countryList: [],
                }));
            }
        }
    }

    const fetchLocationInformation = async (field) => {
        if (field === "country") {
            setLocationList((prev) => ({
                ...prev,
                isCountryFetching: true,
            }));
            try {
                let payload = {
                    actionName: "country"
                }

                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isCountryFetching: false,
                        countryList: response.data.data
                    })
                }
            } catch (error) {
                NotificationManager.error(
                    "Unable to load country list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isCountryFetching: false,
                    countryList: [],
                }));
            }
        }
        else if (field === "state") {
            setLocationList((prev) => ({
                ...prev,
                isStateFetching: true,
            }));
            try {
                let payload = {}
                if (candidateProfileModalData.country.isoCode)
                    payload = {
                        actionName: "state",
                        countryCode: candidateProfileModalData.country.isoCode,
                    }
                else
                    payload = {
                        actionName: "state",
                        countryName: candidateProfileData.country
                    }

                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isStateFetching: false,
                        stateList: response.data.data
                    })
                }

            } catch (error) {
                NotificationManager.error(
                    "Unable to load state list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isStateFetching: false,
                    stateList: [],
                }));

            }
        }
        else if (field === "city") {
            setLocationList((prev) => ({
                ...prev,
                isCityFetching: true,
            }));
            try {
                let payload = {}
                if (candidateProfileModalData.state.isoCode)
                    payload = {
                        actionName: "city",
                        stateCode: candidateProfileModalData.state.isoCode,
                    }
                else
                    payload = {
                        actionName: "city",
                        stateName: candidateProfileData.state
                    }
                let response = await fetchCountryStateCity(payload)
                if (response.status === 200) {
                    setLocationList({
                        ...locationList,
                        isCityFetching: false,
                        cityList: response.data.data
                    })
                }
            } catch (error) {
                NotificationManager.error(
                    "Unable to load city list. Please try again later.",
                    "Error",
                    10000
                )
                setLocationList((prev) => ({
                    ...prev,
                    isCityFetching: false,
                    cityList: [],
                }));
            }
        }
    }

    const openModal = () => {
        let candidateObj = {}
        candidateObj.name = candidateProfileData?.name;
        candidateObj.emailID = candidateProfileData?.emailID;
        candidateObj.countryCallingCode = candidateProfileData?.countryCallingCode;
        candidateObj.phoneNumber = candidateProfileData?.phoneNumber;
        candidateObj.country = {
            name: candidateProfileData?.country || ''
        };
        candidateObj.countryCode = candidateProfileData.countryCode

        if (candidateProfileData?.state) {
            candidateObj.state = {
                name: candidateProfileData?.state || ''
            };

            if (candidateProfileData?.city) {
                candidateObj.city = {
                    name: candidateProfileData?.city || ''
                };
            }
        }

        candidateObj.primarySkill = candidateProfileData?.primarySkill;
        candidateObj.additionalSkills = candidateProfileData?.skills;
        candidateObj.yearsOfExperience = candidateProfileData?.yr_of_exp;
        candidateObj.currentCompensation = candidateProfileData?.currentSalary;
        candidateObj.expectedCompensation = candidateProfileData?.expectedSalary;
        candidateObj.noticePeriod = candidateProfileData?.noticePeriod;
        candidateObj.currency = candidateProfileData?.currency;
        setCandidateProfileModalData(candidateObj);
        setmodalIsOpen(true);
    };

    useEffect(() => {
        const fetchPrimarySkills = async () => {
            try {
                const payload = {
                    userRecruitmentpartnerId: userRecruitmentPartnerId,
                    userId: userId,
                }
                const response = await getAllPrimarySkillData(payload);
                const skills = response.data.data.map(skill => skill.name);
                setPrimarySkill(skills);

            } catch (error) {
                console.error('Error fetching primary skills:', error);
            }
        };
        fetchPrimarySkills();
    }, []);

    const handlePrimarySkillsChange = (event, newValue) => {
        if (newValue) {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                primarySkill: newValue,
            })
        } else {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                primarySkill: "",
            })
        }
        setIsPrimarySkillChange(true);
    };


    const nameChangeHandler = (e) => {
        setCandidateProfileModalData({ ...candidateProfileModalData, name: e.target.value });
    };

    const yearOfExperienceHandler = (e) => {
        setCandidateProfileModalData({ ...candidateProfileModalData, yearsOfExperience: e.target.value });
    }

    const noticePeriodHandler = (e) => {
        setCandidateProfileModalData({ ...candidateProfileModalData, noticePeriod: e.target.value });
    }


    const currentCompensationHandler = (e) => {
        setCandidateProfileModalData({ ...candidateProfileModalData, currentCompensation: e.target.value });
    }

    const expectedCompensationHandler = (e) => {
        setCandidateProfileModalData({ ...candidateProfileModalData, expectedCompensation: e.target.value });
    }


    const currencyChangeHandler = (e, value) => {
        if (value != null) {
            setCandidateProfileModalData({ ...candidateProfileModalData, currency: value.currency });
        }
    }


    const handleSkillsChange = (event, value) => {
        setCandidateProfileModalData({ ...candidateProfileModalData, additionalSkills: value });
        setAdditionalSkills([])

    };

    const additionSkillTextFeildChange = (e) => {
        setCurrentAdditionalValue(e.target.value)
        let arr = [];
        arr.push(e.target.value);
        setAdditionalSkills(arr);
    }

    const handlePhoneNumberChange = (val) => {
        if (val) {
            if (val && isPossiblePhoneNumber(val)) {
                let countryCode_PhoneNumber = `+${parsePhoneNumber(val).countryCallingCode}`
                setCandidateProfileModalData({
                    ...candidateProfileModalData,
                    countryCallingCode: countryCode_PhoneNumber,
                    phoneNumber: val.replace(countryCode_PhoneNumber, ""),
                    phoneNumberInt: countryCode_PhoneNumber 
                })
                setPhoneError(false);
            } else {
                setPhoneError(true);
            }
        }
        else {
            setPhoneError(false);
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                countryCallingCode: '',
                phoneNumber: "",
                phoneNumberInt: ""
            })
        }
    };

    const keypressHandler = (e) => {
        var invalidChars = ["-", "+", "e"];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
    };

    const handleCountryChange = (event, value) => {
        if (!value) {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                country: "",
                state: "",
                city: "",
                countryCode: "",
            })
            setLocationList((prev) => ({
                ...prev,
                stateList: [],
                cityList: [],
            }));
        } else {
            setLocationList((prev) => ({
                ...prev,
                stateList: [],
                cityList: [],
            }));
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                country: value,
                state: "",
                city: "",
                countryCode: value.isoCode,
            })
        }
    };

    const handleStateChange = (e, value) => {
        if (value === null) {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                state: "",
                city: "",
            })
            setLocationList((prev) => ({
                ...prev,
                cityList: []
            }));

        } else {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                state: value,
                city: "",
            })
            setLocationList((prev) => ({
                ...prev,
                cityList: []
            }));
        }
    };

    const handleCityChange = (e, value) => {
        if (value === null) {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                city: "",
            })
        } else {
            setCandidateProfileModalData({
                ...candidateProfileModalData,
                city: value,
            })
        }
    };



    const updateCandidateData = async () => {
        if (phoneError === true) {
            NotificationManager.error(
                "Please enter a valid phone number",
                "Error",
                10000
            );
            return;
        }
        else if (candidateProfileModalData.name === "" ||
            candidateProfileModalData.phoneNumber === "" ||
            candidateProfileModalData.emailID === "" ||
            candidateProfileModalData.country === "" ||
            candidateProfileModalData.primarySkill === "") {
            NotificationManager.error(
                "Please fill in all the details",
                "Error",
                10000
            );
            return;
        } else {
            let additionalSkillArr = candidateProfileModalData.additionalSkills
            ? candidateProfileModalData.additionalSkills.filter(skill => skill && skill.trim() !== '')
            : [];
            if (isPrimarySkillChange && (candidateProfileData?.primarySkill !== candidateProfileModalData.primarySkill)) {
                let i = additionalSkillArr.indexOf(candidateProfileModalData.primarySkill);
                if (i !== -1) {
                    additionalSkillArr.splice(i, 1);
                }
                const index = additionalSkillArr.indexOf(candidateProfileData?.primarySkill);
                if (index !== -1) {
                    additionalSkillArr.splice(index, 1);
                }
                additionalSkillArr.unshift(candidateProfileData?.primarySkill);
            }
            let cleanPhoneNumber = (candidateProfileModalData.phoneNumber || "").replace(/[^\d+]/g, "");
            if (!cleanPhoneNumber.startsWith("+") && candidateProfileModalData.countryCallingCode) {
                cleanPhoneNumber = `${candidateProfileModalData.countryCallingCode}${cleanPhoneNumber}`;
            }

            setisUserdataUpdating(true)

            const payload = {
                emailID: candidateProfileModalData.emailID,
                phoneNumber: cleanPhoneNumber,
                name: candidateProfileModalData.name,
                primarySkill: candidateProfileModalData.primarySkill,
                skills: additionalSkillArr,
                city: candidateProfileModalData.city?.name,
                state: candidateProfileModalData.state?.name,
                country: candidateProfileModalData.country?.name,
                countryCode: candidateProfileModalData?.countryCode,
                countryCallingCode: candidateProfileModalData?.countryCallingCode,
                currency: candidateProfileModalData?.currency,
                yr_of_exp: candidateProfileModalData?.yearsOfExperience,
                currentSalary: parseInt(candidateProfileModalData?.currentCompensation),
                expectedSalary: parseInt(candidateProfileModalData?.expectedCompensation),
                noticePeriod: parseInt(candidateProfileModalData?.noticePeriod),
                lastUpdatedBy: userId,
                recruitmentOrgId: userRecruitmentPartnerId,
            }
            try {
                const response = await updateResume(candidateResumeId, payload);
                if (response.status === 200) {
                    NotificationManager.success("Candidate Profile is successfully updated", "success",10000);
                    let tempCandidateProfileData = { ...candidateProfileData };
                    tempCandidateProfileData.name = candidateProfileModalData.name;
                    tempCandidateProfileData.phoneNumber = candidateProfileModalData.phoneNumber;
                    tempCandidateProfileData.emailID = candidateProfileModalData.emailID;
                    tempCandidateProfileData.primarySkill = candidateProfileModalData.primarySkill;
                    tempCandidateProfileData.skills = candidateProfileModalData.additionalSkills;
                    tempCandidateProfileData.city = candidateProfileModalData?.city?.name;
                    tempCandidateProfileData.state = candidateProfileModalData?.state?.name;
                    tempCandidateProfileData.country = candidateProfileModalData?.country?.name;
                    tempCandidateProfileData.countryCode = candidateProfileModalData.countryCode;
                    tempCandidateProfileData.countryCallingCode = candidateProfileModalData.countryCallingCode;
                    tempCandidateProfileData.currency = candidateProfileModalData?.currency;
                    tempCandidateProfileData.yr_of_exp = candidateProfileModalData.yearsOfExperience;
                    tempCandidateProfileData.currentSalary = parseInt(candidateProfileModalData.currentCompensation);
                    tempCandidateProfileData.expectedSalary = parseInt(candidateProfileModalData.expectedCompensation);
                    tempCandidateProfileData.noticePeriod = parseInt(candidateProfileModalData.noticePeriod);
                    tempCandidateProfileData.lastUpdatedBy = userId;
                    tempCandidateProfileData.updated_at = response.data.updated;
                    setCandidateProfileData(tempCandidateProfileData);
                    closeAddModal();
                    setisUserdataUpdating(false)
                }
                else if (response.status === 202) {
                    NotificationManager.error(response.data.message, "Error",10000);
                    setisUserdataUpdating(false);
                }

            } catch (error) {
                if (error?.response?.status === 400) {
                    const errorMessage = error.response.data.errMessage;
                    NotificationManager.error(errorMessage, "Error", 10000);
                }
               setisUserdataUpdating(false);
            }
        }
    }


    const handleclose = () => {
        setSelectedFile("")
    }


    function create_UUID() {
        let dt = new Date().getTime();
        const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = (dt + Math.random() * 16) % 16 | 0;
                dt >>>= 4; // unsigned right shift to ensure a 32-bit integer
                return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
            }
        );
        return uuid;
    }

    function hash_UUID(uuid) {
        return SHA256(uuid).toString();
    }


    const delayedFunction = async (filnameWithtimearr) => {

        const response = await countNoOfFilesParsed(filnameWithtimearr);

        if (response.status === 200) {

            uploadedFileParseCount.current = response.data.count;
        }
    }

    const uploadResumeToBlobStorage = async (blob) => {
        setmodalIsOpen(false)
        backdropChangeHandler(true)
        let filnameWithtimearr = []
        try {

            const sas = decodeURI(jsonConfig.sasResumeToken);
            const date = DateTime.now();
            const currentDate = date.toFormat("yyyy-MM-dd");
            const formattedDate = date.toFormat("yyyy-MM-dd'T'HH:mm:ss.SSSZZ");

            const bsClient = new BlobServiceClient(
                `https://${jsonConfig.blobStorageResumeAccountName}.blob.core.windows.net${sas}`
            );
            await uploadResumeLogs({ userId: localStorage.getItem('userID'), recruitementPartnerId: userRecruitmentPartnerId })

            const containerClient = bsClient.getContainerClient("staging");

            var v = blob.name.split(".");
            let uuid = create_UUID();
            let hashUuid = hash_UUID(uuid);
            let blobName = currentDate + "/" + userId + "/" + hashUuid + "." + v[v.length - 1];
            const blobClient = containerClient.getBlockBlobClient(blobName);

            const blobUploadOptions = {
                blobHTTPHeaders: {
                    blobContentType: blob.type,
                },
                metadata: {
                    "createdtime": formattedDate,
                    "fullname": blob.name,
                    "uploadedtype": "Recruiter Upload",
                    "organizationid": userRecruitmentPartnerId,
                    "blobfilename": blobName

                },
            };


            filnameWithtimearr.push({ "blobfilename": blobName, "createdtime": formattedDate, "organizationid": userRecruitmentPartnerId, "userRecruitmentpartnerId": userRecruitmentPartnerId, "userId": userId })


            await blobClient.uploadBrowserData(blob, blobUploadOptions);

            const intervalID = setInterval(() => {
                if (stopCondition(filnameWithtimearr)) {
                    delayedFunction(filnameWithtimearr);
                } else {
                    clearInterval(intervalID);
                    backdropChangeHandler(false)

                    window.location.reload();
                }
            }, filnameWithtimearr.length * 5000);

            setSelectedFile({})
        } catch (error) {
            setSelectedFile({})
            console.error("An error occurred during upload:", error);
        }
    };

    const stopCondition = (filnameWithtimearr) => {
        if (uploadedFileParseCount.current === filnameWithtimearr.length) {
            return false
        } else {
            return true
        }
    }

    const goToCandidateHistory = () => {
        history("/candidate-history",
            {
                state: {
                    candidateEmail: candidateProfileData.emailID,
                    recruitmentOrgId: userRecruitmentPartnerId,
                    checkCandidateHistory: true
                },

            });
    }

    const handleResumeLoader = (loader) => {
        // setIsResumeUploadLoader(loader);
    };

    const handleDataFromModal = (data) => {
        // setResumeLinkData(data[0].URL);
    };

    // Handler for upload completion
    const handleUploadComplete = (uploadedFiles) => {
        NotificationManager.success("Resume uploaded successfully!", "Success", 10000);
        // Optionally refresh data here
    };

    return (
        <>
            {loadingController ? (
                <>
                    <div className="profileHeading">
                        <div className="candidateProfilecontainer_pencil">
                            <div className="poweResumeHeading_poweResumeRight">Candidate Profile</div>
                            <span className="pencilIcon_profilecompletion" ><img src={pencil} alt="" onClick={openModal} /></span>
                        </div>
                        <div className="poweResumeLastUpdated_poweResumeRight">
                            Last updated {candidateProfileData?.updated_at ? DateTime.fromISO(candidateProfileData?.updated_at).toFormat("dd-LLL-yyyy, hh:mm:ss a") : ''}
                        </div>
                    </div>
                    <div className="firstBlueContainer">

                        <div className="imgAndCVContainer">
                            {/* image */}
                            <div className="imageContainer">
                                <img
                                    src={profileCompletion?.profilePicUrl || profilePicture}
                                    alt=""
                                    className="only_candidate_profileImage_admin"
                                />

                            </div>
                            {/* resume  */}
                            {candidateProfileData?.resumeUrl ?
                                <div className="resumeContainer">
                                    <div className="color_04093f viewresume_container_profilecomplete" onClick={(e) => openResume(candidateProfileData.resumeUrl)}>{candidateProfileData?.resumeUrl ? fileExtension(candidateProfileData?.resumeUrl) : ""}
                                        <span className="viewText">View Resume</span>
                                    </div>
                                </div>
                                :
                                <div className="resumeContainer_noresume">
                                    {!selectedFile.name && (userType !== "Candidate") ?
                                        <>
                                            <Button
                                                className={userType === "Admin" ? "candidate_filepicker_button_disable" : "candidate_filepicker_button_profileCompleted_noresume"}
                                                disabled={userType === "Admin"}
                                                onClick={() => { setShowResumeModal(true) }}
                                            >Choose Resume</Button>
                                            <UploadResumeModal
                                                showResumeModal={showResumeModal}
                                                setShowResumeModal={setShowResumeModal}
                                                id={idContextTest}
                                                userRecruitmentpartnerId={userRecruitmentPartnerId}
                                                onUploadComplete={handleUploadComplete}
                                                singleFileSelect={true}
                                            />
                                        </>
                                        : <>
                                            <div className="uploadFuctionContainer_conditional_profileComplete">
                                                <div className="uploadcontainer_profile_complete">

                                                    <div className="uploadFuctionCon_profileComplete">
                                                        <CancelTwoToneIcon onClick={(e) => handleclose()} className="close_icon_newCandidate" />
                                                        <div className="candidateFileExtention">{fileExtensionuploadResume()}</div>
                                                    </div>
                                                    <Button
                                                        className="candidate_filepicker_button_profileComplete"
                                                        onClick={(e) => uploadResumeToBlobStorage(selectedFile)}
                                                    >
                                                        upload Resume
                                                    </Button>

                                                </div>


                                            </div>
                                        </>}
                                </div>}
                        </div>



                        {/* candidate details */}
                        {Object.keys(candidateProfileData).length > 0 ?
                            <div className="detailsContainer">
                                <div className="partitionContainer">
                                    <div className="candidateName">{candidateProfileData?.name}</div>
                                    <div className="candidateDetails">{candidateProfileData?.emailID ?
                                        getWrappedEmail(candidateProfileData?.emailID)
                                        : ""}</div>
                                    {/* In the display section, update the phone number display: */}
                                    <div className="candidateDetails">
                                        Ph: <span className="candidate_data_value">
                                            {candidateProfileData?.phoneNumber ?
                                                (candidateProfileData?.phoneNumber.startsWith('+') ?
                                                    candidateProfileData.phoneNumber : 
                                                    `${candidateProfileData?.countryCallingCode || ''} ${candidateProfileData?.phoneNumber}`
                                                ) : ""
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className="partitionContainer">
                                    {(candidateProfileData?.address !== '' || candidateProfileData?.city !== '' || candidateProfileData?.state !== '' || candidateProfileData?.country !== '') ? (<>
                                        <p className="candidateDetails">Address:<span className="candidate_data_value">{candidateProfileData?.address ? candidateProfileData?.address + ", " : ""}</span></p>
                                        {candidateProfileData?.city ? <p className="candidateDetails"><span className="candidate_data_value">{candidateProfileData?.city},</span></p> : ""}
                                        {candidateProfileData?.state ? <p className="candidateDetails"><span className="candidate_data_value">{candidateProfileData?.state},</span></p> : ""}
                                        {candidateProfileData?.country ? <p className="candidateDetails"><span className="candidate_data_value">{candidateProfileData?.country}</span></p> : ""}
                                    </>
                                    )
                                        : <p className="candidateDetails">Address: N/A</p>}
                                </div>
                                <div>
                                    <div className="candidateDetails">Upload: <span className="candidate_data_value">{candidateProfileData?.recruiterName ? candidateProfileData?.recruiterName : ""}</span></div>
                                    <div className="candidateDetails">Initial Upload: <span className="candidate_data_value">{candidateProfileData?.initialUploadDate ? DateTime.fromISO(candidateProfileData?.initialUploadDate).toFormat("dd-LLL-yyyy") : candidateProfileData?.created_at ? DateTime.fromISO(candidateProfileData?.created_at).toFormat("dd-LLL-yyyy") : ""}</span> </div>
                                    <div className="candidateDetails">Last Upload: <span className="candidate_data_value">{candidateProfileData?.lastUploadDate ? DateTime.fromISO(candidateProfileData?.lastUploadDate).toFormat("dd-LLL-yyyy") : candidateProfileData?.created_at ? DateTime.fromISO(candidateProfileData?.created_at).toFormat("dd-LLL-yyyy") : ""}</span> </div>
                                </div>
                            </div>
                            :
                            <div className="detailsContainer">
                                <div className="partitionContainer_skeleton">
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                </div>
                                <div className="partitionContainer_skeleton">
                                    <Skeleton variant="rect" height={12} width={100} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                </div>
                                <div className="partitionContainer_skeleton">
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                    <Skeleton variant="rect" height={12} width={240} animation="wave" />
                                </div>
                            </div>
                        }
                    </div>
                    {/* bottom cards */}
                    <div className="cardsContainer">
                        <div className="cardStyle">
                            <div className="primarySkillTitle_poweResumeRight">Employment</div>
                            <div className="cardContent_primaryskill">
                                <div className="skillCardCaptions">Currently working : <span className="candidate_data_value">{statusCode === configJSON.candidateRequisitionStatusCode.STARTED ? 'Yes' : 'No'}</span></div>
                                <div className="skillCardCaptions">Company name : <span className="candidate_data_value">{companyName || 'N/A'}</span></div>
                            </div>
                        </div>
                        {candidateProfileData?.primarySkill ?
                            <div className="cardStyle">
                                <div className="primarySkillTitle_poweResumeRight">Primary Skill</div>
                                <div className="cardContent_primaryskill">
                                    <div className="PrimarySkillName_poweResumeRight">{candidateProfileData?.primarySkill ? candidateProfileData?.primarySkill : ''}</div>
                                    <div className="skillCardCaptions">Years of Experience: <span className="candidate_data_value">{candidateProfileData?.yr_of_exp ? candidateProfileData?.yr_of_exp : "N/A"}</span></div>
                                </div>
                            </div>
                            : null}
                        {candidateProfileData?.skills?.length > 0 ?
                            <div className="cardStyle">
                                <div className="primarySkillTitle_poweResumeRight">Secondary Skill</div>
                                <div className="chipContainer">
                                    {(candidateProfileData?.skills?.length > 15 && !wrappedAdditionalSkills) ? <>
                                        {getWrappedSecondarySkills(candidateProfileData?.skills)}
                                        <span className="morelesscount" onClick={(e) => setWrappedAdditionalSkills(true)}>...{candidateProfileData?.skills?.length - 15} more</span>
                                    </> : <>
                                        {getAllSecondarySkills(candidateProfileData?.skills)}
                                        {candidateProfileData?.skills?.length > 15 && wrappedAdditionalSkills ? <span className="morelesscount" onClick={(e) => setWrappedAdditionalSkills(false)}>...show less</span> : ""}
                                    </>}
                                </div>
                            </div>
                            : null}
                        {candidateProfileData?.currentSalary || candidateProfileData?.expectedSalary ?
                            <div className="cardStyle">
                                <div className="primarySkillTitle_poweResumeRight">Compensation</div>
                                <div className="cardContent">
                                    {candidateProfileData?.currentSalary ? <div className="skillCardCaptions">Current Compensation: <span className="candidate_data_value">{candidateProfileData?.currency} {candidateProfileData?.currentSalary}</span></div> : ""}
                                    {candidateProfileData?.expectedSalary ? <div className="skillCardCaptions">Expected Compensation: <span className="candidate_data_value">{candidateProfileData?.currency} {candidateProfileData?.expectedSalary}</span></div> : ""}
                                </div>
                            </div>
                            : null}
                        {candidateProfileData?.noticePeriod ?
                            <div className="cardStyle">
                                <div className="primarySkillTitle_poweResumeRight">Notice Period</div>
                                <div className="cardContent">
                                    <div className="skillCardCaptions">Notice Period: <span className="candidate_data_value">{candidateProfileData?.noticePeriod ? candidateProfileData?.noticePeriod : ""}</span></div>
                                </div>
                            </div>
                            : null}
                        {candidateProfileData?.oldProfiles?.length > 0 && candidateProfileData.oldProfiles[0] ?
                            <div className="cardStyle">
                                <p className="primarySkillTitle_poweResumeRight">Older Profile</p>
                                {candidateProfileData?.oldProfiles?.length > 0 ?
                                    <>
                                        {candidateProfileData?.oldProfiles?.length > 0 ?
                                            <div className="multiProfileBox_olderProfile viewresume_container_profile">
                                                <span className="skillCardCaptions">Profile 1: </span>
                                                <div className="viewresume_container_value" onClick={(e) => openResume(candidateProfileData?.oldProfiles[0])}>
                                                    {candidateProfileData?.oldProfiles?.length > 0 ? fileExtensionArr(candidateProfileData?.oldProfiles[0]) : ""}
                                                    <span className="skillCardCaptions">View Resume</span>
                                                </div>
                                            </div> : ""}
                                        {candidateProfileData?.oldProfiles?.length > 1 ?
                                            <div className="multiProfileBox_olderProfile viewresume_container_profile">
                                                <span className="skillCardCaptions">Profile 2: </span>
                                                <div className="viewresume_container_value" onClick={(e) => openResume(candidateProfileData?.oldProfiles[1])}>
                                                    {candidateProfileData?.oldProfiles?.length > 1 ? fileExtensionArr(candidateProfileData?.oldProfiles[1]) : ""}
                                                    <span className="skillCardCaptions">View Resume</span>
                                                </div>
                                            </div> : ""}
                                    </>
                                    :
                                    null}
                            </div>
                            : null}
{(testData?.AI?.length > 0 || testData?.VET?.length > 0) && (
                        <div className="cardStyle testTakenCard">
    <div className="primarySkillTitle_poweResumeRight">Test Taken</div>
{ (testData?.AI?.length > 0) && (


    <Accordion className="testAccordion">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="accordionTitle">
                AI Tests ({testData.AI.length})
                
            </div>
        </AccordionSummary>
        <AccordionDetails>
            {testData.AI.length > 0 ? (
                testData.AI.map((test, index) => (
                    <div key={index} className="testItem" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
                        <span className="testName">{test.name}</span>
                        {test.id && (
                            <button
                                className="testLink"
                                onClick={() => navigateToTestAnalysis(test.id, 'ai')}
                                style={{ padding: '4px 12px', cursor: 'pointer' }}
                            >
                                View Test
                            </button>
                        )}
                    </div>
                ))
            ) : (
                <div className="noTestsMessage">No AI tests taken yet</div>
            )}
        </AccordionDetails>
    </Accordion>
)}

{
    (testData?.VET?.length > 0) && (

    <Accordion className="testAccordion">
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="accordionTitle">
                VET Tests ({testData.VET.length})
                
            </div>
        </AccordionSummary>
        <AccordionDetails>
            {testData.VET.length > 0 ? (
                testData.VET.map((test, index) => (
                    <div key={index} className="testItem" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
                        <span className="testName">{test.name}</span>
                        {test.id && (
                            <button
                                className="testLink"
                                onClick={() => navigateToTestAnalysis(test.id, 'vet')}
                                style={{ padding: '4px 12px', cursor: 'pointer' }}
                            >
                                View Test
                            </button>
                        )}
                    </div>
                ))
            ) : (
                <div className="noTestsMessage">No VET tests taken yet</div>
            )}
        </AccordionDetails>
    </Accordion>

    )}
</div>
)}
                        {
                            userType === "Admin" ? <></>
                                :
                                <div className="candidateHistoryDiv">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={goToCandidateHistory}
                                    >
                                        <TimelineIcon />
                                        Candidate History
                                    </Button>
                                </div>
                        }


                        

                    </div>

                    
                    <Dialog
                        open={modalIsOpen}
                        onClose={closeAddModal}
                        aria-labelledby="customized-dialog-title"
                        maxWidth="sm"
                        fullWidth={true}
                    >
                        <DialogTitle className="dialogtitle_profilecompletion_dialog">
                            <div className="candidateProfile_text">Candidate Profile </div>
                            <div><CloseIcon onClick={closeAddModal} className="closeIconProfileComplete" /></div>
                        </DialogTitle>
                        <DialogContent>
                            <div className="dialogContainer_name">
                                <div className="inputLabel_right">Name*</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Name"
                                        className="admin_textbox"
                                        value={candidateProfileModalData?.name ? candidateProfileModalData?.name : ""}
                                        onChange={(e) => nameChangeHandler(e)}
                                    />
                                </FormControl>
                            </div>
                            <div className="dialogContainer_email mt-15">
                                <div className="inputLabel_right">Email*</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Email Address"
                                        className="admin_textbox"
                                        value={candidateProfileModalData?.emailID ? candidateProfileModalData?.emailID : ""}
                                        disabled
                                    />
                                </FormControl>
                            </div>
                            <div className="dialogContainer_phone mt-15">
                                <div className="inputLabel_right">Phone Number*</div>
                                <FormControl fullWidth variant="outlined">
                                    <PhoneInput
                                        international
                                        className="textbox_phone_input_pendingResume"
                                        placeholder="Enter Phone Number"
                                        value={
                                            candidateProfileModalData?.phoneNumber?.startsWith('+')
                                                ? candidateProfileModalData.phoneNumber
                                                : `${candidateProfileModalData?.countryCallingCode || ''} ${candidateProfileModalData?.phoneNumber || ''}`
                                        }
                                        onChange={(val) => handlePhoneNumberChange(val)}
                                        onKeyPress={(e) => keypressHandler(e)}
                                    />
                                    {phoneError && (
                                        <FormHelperText error>Please enter a valid phone number</FormHelperText>
                                    )}
                                </FormControl>
                            </div>
                            <div className="locationItemsContainer mt-15">
                                <div className="inputLabel_right">Address</div>
                                <div className="locationContainer_profilecomplete">
                                    <div className="locationitemcontainer_profilecomplete">
                                        <div className="inputLabel_right">Country*</div>
                                        <Autocomplete
                                            id="combo-box-demo"
                                            className={candidateProfileModalData?.country !== "" ? "mt_14" : "admin_textbox_error"}
                                            options={locationList.countryList}
                                            onFocus={() => locationList.countryList.length > 0 ? null : fetchLocationInformation("country")}
                                            loading={locationList.isCountryFetching}
                                            autoHighlight
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) =>
                                                option.name
                                                    ? option.name
                                                    : ""
                                            }
                                            value={candidateProfileModalData?.country}
                                            onChange={handleCountryChange}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    required={true}
                                                    placeholder="Please Select Country"
                                                    slotProps={{
                                                        input: {
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {locationList.isCountryFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        },
                                                    }}
                                                />}
                                        />
                                    </div>
                                    <div className="locationitemcontainer_profilecomplete">
                                        <div className="inputLabel_right">State</div>
                                        <Autocomplete
                                            id="combo-box-demo"
                                            className="mt_14"
                                            options={locationList.stateList}
                                            loading={locationList.isStateFetching}
                                            onFocus={() => locationList.stateList.length > 0 ? null : fetchLocationInformation("state")}
                                            autoHighlight
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) =>
                                                option.name ? option.name : ""
                                            }
                                            value={candidateProfileModalData?.state || ""}
                                            onChange={handleStateChange}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    required={true}
                                                    placeholder="Please Select State"
                                                    slotProps={{
                                                        input: {
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {locationList.isStateFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        },
                                                    }}
                                                />}
                                        />
                                    </div>
                                    <div className="locationitemcontainer_profilecomplete">
                                        <div className="inputLabel_right">City</div>
                                        <Autocomplete
                                            id="combo-box-demo"
                                            className="mt_14"
                                            onFocus={() => locationList.cityList.length > 0 ? null : fetchLocationInformation("city")}
                                            options={locationList.cityList}
                                            loading={locationList.isCityFetching}
                                            autoHighlight
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) =>
                                                option.name ? option.name : ""
                                            }
                                            value={candidateProfileModalData?.city || ""}
                                            onChange={handleCityChange}
                                            renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Please Select City"
                                                slotProps={{
                                                    input: {
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {locationList.isCityFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                                                {params.InputProps.endAdornment}
                                                            </>
                                                        ),
                                                    },
                                                }}
                                            />}
                                        />
                                    </div>
                                </div>
                            </div>



                            <div className="dialogContainer mt-15">
                                <div className="inputLabel_right">Primary Skill*</div>
                                <Autocomplete
                                    id="multiple-limit-tags"
                                    getOptionLabel={(option) => option}
                                    options={primarySkill}
                                    value={candidateProfileModalData?.primarySkill || ""}
                                    freeSolo
                                    className="admin_textbox"
                                    onChange={handlePrimarySkillsChange}
                                    filterSelectedOptions
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            placeholder='Select Primary Skill'
                                            variant="outlined"
                                            fullWidth
                                        />
                                    }
                                />
                            </div>
                            <div className="dialogContainer mt-15">
                                <div className="inputLabel_right">Years of Experience</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Years of Experience"
                                        className="admin_textbox"
                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={candidateProfileModalData?.yearsOfExperience || ""}
                                        onChange={yearOfExperienceHandler}
                                    />
                                </FormControl>
                            </div>
                            <div className="dialogContainer mt-15">
                                <div className="inputLabel_right">Secondary Skill</div>
                                <Autocomplete
                                    multiple
                                    limitTags={4}
                                    id="multiple-limit-tags"
                                    options={additionalSkills}
                                    getOptionLabel={(option) => option}
                                    value={candidateProfileModalData?.additionalSkills || []}
                                    onChange={(event, value) => handleSkillsChange(event, value)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            value={currentAdditionalValue}
                                            onChange={(e) => additionSkillTextFeildChange(e)}
                                            placeholder="Select Additional Skills" />
                                    )}
                                />

                            </div>
                            <div className="itemContainer mt-15">
                                <div className="inputLabel_right">Compensation</div>
                                <div className="compensationcontainer">
                                    <div className="currentCompensation">
                                        <div className="inputLabel_right">Current Compensation</div>
                                        <div className="currency_CompensationContainer">
                                            <Autocomplete
                                                id="combo-box-demo"
                                                className='admin_textbox_currency_profileComplete'
                                                options={locationList.countryList}
                                                getOptionLabel={(option) => option?.currency || ""}
                                                value={candidateProfileModalData || ""}
                                                loading={locationList.isCurrencyFetching}
                                                onFocus={() => locationList.countryList.length > 0 ? null : fetchLocationCurrency("country")}
                                                onChange={currencyChangeHandler}
                                                renderInput={(params) => <TextField {...params} placeholder="Currency" variant="outlined" 
                                                slotProps={{
                                                        input: {
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {locationList.isCurrencyFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        },
                                                    }}
                                                    />}
                                            />
                                            <FormControl fullWidth variant="outlined">
                                                <OutlinedInput
                                                    placeholder="Current Compensation"
                                                    className="currncy_compensationstyle2"
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    value={candidateProfileModalData?.currentCompensation || ""}
                                                    onChange={currentCompensationHandler}
                                                />
                                            </FormControl>
                                        </div>

                                    </div>
                                    <div className="expectedCompensation">
                                        <div className="inputLabel_right">Expected Compensation</div>
                                        <div className="currency_CompensationContainer">
                                            <Autocomplete
                                                id="combo-box-demo"
                                                className='currncy_compensationstyle1 '
                                                placeholder="Currency"
                                                options={currencyList}
                                                getOptionLabel={(option) => option?.currency || ""}
                                                value={candidateProfileModalData || ""}
                                                onChange={(e) => currencyChangeHandler(e)}
                                                renderInput={(params) => <TextField {...params} placeholder="Currency" variant="outlined" />}
                                            />
                                            <FormControl fullWidth variant="outlined">
                                                <OutlinedInput
                                                    placeholder="Expected Compensation"
                                                    className="currncy_compensationstyle2"
                                                    type="number"
                                                    inputProps={{ min: 0 }}
                                                    value={candidateProfileModalData?.expectedCompensation || ""}
                                                    onChange={expectedCompensationHandler}
                                                />
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="dialogContainer mt-15">
                                <div className="inputLabel_right">Notice Period(Days)</div>
                                <FormControl fullWidth variant="outlined">
                                    <OutlinedInput
                                        placeholder="Notice Period(Days)"
                                        className="admin_textbox"
                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={candidateProfileModalData?.noticePeriod || ""}
                                        onChange={noticePeriodHandler}
                                    />
                                </FormControl>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <button variant="outlined" color="primary" onClick={closeAddModal} className="cancelButton_profileComplete">
                                Cancel
                            </button>

                            <button
                                variant="contained"
                                color="primary"
                                className={isUserdataUpdating ? "saveButtonProfileComplete_disabled" : "saveButtonProfileComplete"}
                                disabled={isUserdataUpdating}
                                onClick={updateCandidateData}
                            >
                                <span>Save</span>
                                {isUserdataUpdating ? <CircularProgress /> : ""}
                            </button>
                        </DialogActions>
                    </Dialog>
                </>
            ) : (
                <></>
            )}

            {showResumeModal && <UploadResumeModal
                showResumeModal={showResumeModal}
                setShowResumeModal={setShowResumeModal}
                id={idContextTest}
                sendDataToActivityModal={handleDataFromModal}
                handleResumeLoader={handleResumeLoader}
                activityModalUsed={false}
                userRecruitmentpartnerId={userRecruitmentPartnerId}
                singleFileSelect={true}
            />}
        </>
    );
};

export default ProfileCompletion;
